module.exports = __webpack_public_path__ + "images/icons/nonsmoker.6a99566ab5a920e6dd912d237cba6d92.png";